export const workingSchedule = ['2/2', '5/2', '2/5'];
export const workingScheduleOutside = ['2/2', '5/2', '2/5', 'Без ограничений'];
export const roles = ['master', 'Regional manager'];
